import '@webcomponents/webcomponentsjs/webcomponents-bundle.js'
import '@webcomponents/webcomponentsjs/custom-elements-es5-adapter.js'
import GonCampaignAccessor from '../../common/helper/gon_campaign_accessor.js'

class GamplaEntryBtn extends HTMLElement {
    constructor() {
        super()
        this._onClick = this._onClick.bind(this)
        this._onKeyDown = this._onKeyDown.bind(this)
        this._isAddedEventListener = false
    }

    connectedCallback() {
        this.setAttribute('role', 'button')

        // data-entry-stateの処理
        // gonCampaignAccessor.entryButtonStatusが存在する場合、data-entry-stateを置き換える
        let currentEntryButtonStatus = "";
        // モジュールテンプレートeditor-canvas内では、gonCampaignAccessorが利用できない場合がある
        const gonCampaignAccessor = new GonCampaignAccessor()
        if (gonCampaignAccessor.entryButtonStatus) {
            currentEntryButtonStatus = gonCampaignAccessor.entryButtonStatus
            this.setAttribute('data-entry-state', currentEntryButtonStatus)
        }

        if (!this._isAddedEventListener) {
            if (currentEntryButtonStatus == "open") {
                this._isAddedEventListener = true
                this.addEventListener('click', this._onClick)
                this.addEventListener('keydown', this._onKeyDown)
                // カスタムエレメントをフォーカス可能にする
                this.setAttribute('tabindex', '0')
            } else {
                this.setAttribute('aria-disabled', 'true')
            }
        }
    }

    disconnectedCallback() {
        if (this._isAddedEventListener) {
            this.removeEventListener('click', this._onClick)
            this.removeEventListener('keydown', this._onKeyDown)
            this._isAddedEventListener = false
        }
    }

    _onKeyDown(event) {
        // EnterキーまたはSpaceキーでクリック処理を実行
        if (event.key === 'Enter' || event.key === ' '|| event.key === 'Spacebar') {
            event.preventDefault()
            this._onClick()
        }
    }

    _onClick() {
        // プレビュー画面の場合、エントリー処理は行わない
        if (!location.pathname.match(/^\/campaign/)) return

        const formTag = document.createElement('form')
        document.body.appendChild(formTag)

        const inputTag = document.createElement('input')
        inputTag.setAttribute('type', 'hidden' )
        inputTag.setAttribute('name', 'entry_button[entity_id]')
        inputTag.setAttribute('value', this.id)
        formTag.appendChild(inputTag)

        const csrfToken = document.querySelector("meta[name='csrf-token']").getAttribute("content");
        const csrfElement = document.createElement("input");
        csrfElement.setAttribute("type", "hidden");
        csrfElement.setAttribute("name", "authenticity_token");
        csrfElement.setAttribute("value", csrfToken);
        formTag.appendChild(csrfElement);

        formTag.setAttribute('method', 'post')
        formTag.setAttribute('action', location.pathname + '/entry' + location.search) // include extend_parameter

        formTag.submit()
    }

}
customElements.define('gampla-entry-btn', GamplaEntryBtn)
